/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { url } from 'utils/urls';
import PercentageBar from 'components/shared/percentagebar/percentagebar'
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/image2/answer/answer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ IMAGE 2 ANSWER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const Image2Answer = (props) => {
	let inlineStyles = {
		'background-image': `url(${url.image.client}${props.image})`
	};
    return(
        <span className={`${sheet.classes.uniqueanswer} uniqueanswer`}>
        	<span className={`${sheet.classes.graphic} graphic`} style={inlineStyles}></span>
            { props.isResult ? <PercentageBar type={`vertical2`} barCoefficient={props.barCoefficient} amount={`${props.predictionPercentage}`} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} /> : null }
        </span>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Image2Answer;
